import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { DetailsContainer, Footer, Title, Content, Body } from '../DefaultStyles/Shared';
import { Container } from '../DefaultStyles/Details';
import ShareDrawer from '../../components/ShareDrawer';
import VideoPlayer from '../../components/Video/Video';

import { onBackWithinCard, setOverlayPartnerVisible } from '../Widget/actions';

import { isLongText } from '../../components/Shared/commonFunctions';
import { ActionTypes, CardTypes } from '../../utils/enums';

const Video = props => (
    <Container>
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <Body>
            <WidgetHeader />
            <Content isVideoCard={true} isSingleAction={true}>
                <Title
                    isShortText={!isLongText(props.cardTitle, 28)}
                    isLongText={isLongText(props.cardTitle, 60)}
                    isExtraLongText={isLongText(props.cardTitle, 95)}
                    isVideoCard={true}
                    onClick={e => {
                        props.setOverlayPartnerVisible(true, e, false);
                    }}
                    dangerouslySetInnerHTML={{
                        __html: props.cardTitle
                    }}
                />
                <DetailsContainer id="videoContainer" isVideoCard={true}>
                    <VideoPlayer
                        url={props.videoUrl}
                        autoplay={!props.isVideoFrontCard}
                        muted={props.isVideoFrontCard}
                        isLongText={isLongText(props.cardTitle, 35)}
                    />
                </DetailsContainer>
            </Content>
            <Footer>
                <ShareDrawer
                    goBack={() =>
                        props.card.type === CardTypes.actionChoice
                            ? props.onBackWithinCard(
                                  props.actionIdentifier,
                                  props.card,
                                  true,
                                  true
                              )
                            : null
                    }
                    fullwidth={props.card.type === CardTypes.actionChoice}
                    rightAlign={props.card.type !== CardTypes.actionChoice}
                    hasBackButton={props.card.type === CardTypes.actionChoice}
                    backgroundColor={'#fff'}
                />
            </Footer>
        </Body>
    </Container>
);

Video.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    card: PropTypes.object.isRequired,
    cardTitle: PropTypes.string.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    isVideoFrontCard: PropTypes.bool.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    videoUrl: PropTypes.string
};

export default connect(
    state => {
        return {
            actionIdentifier: state.widget.activeAction.identifier,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            cardTitle: state.widget.cards[
                state.widget.activeAction.order - 1
            ].heading.replace(/@articleUrl/g, state.widget.articleUrl),
            videoUrl:
                state.widget.activeAction.type === 'video'
                    ? state.widget.activeAction.url
                    : null,
            isVideoFrontCard:
                state.widget.cards[state.widget.activeAction.order - 1].order.value ===
                    1 && state.widget.activeAction.type === 'video'
        };
    },
    {
        onBackWithinCard,
        setOverlayPartnerVisible
    },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Video) return true;

            return next === prev;
        }
    }
)(Video);
